<template>
  <div class="flex_center_nowrap" style="width:100%;height:100%">
    <div style="width:650px;height:480px;">
      <img
        src="@/assets/images/404.png"
        style="width:100%;height:100%"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped></style>
